module.exports = __webpack_public_path__ + "img/bg-text.43cbb976.svg";